import styled from 'styled-components';

export const Wrapper = styled.div`
	z-index: 9;
	display: flex;
	flex-flow: row nowrap;
	height: 100%;
	left: 0;
	position: absolute;
	width: 750px;
	@media screen and (max-width: 1500px) {
		width: 600px;
	}
	@media screen and (max-width: 1200px) {
		width: 500px;
	}
	@media screen and (max-width: 600px) {
		left: 50%;
		transform: translate(-50%, -50%);
		width: 95%;
		height: 97%;
		top: 50%;
	}
	@media screen and (max-width: 500px) {
		width: 100%;
		height: 100%;
	}
`;

export const LeftSection = styled.div<{ twoFactorActive: boolean }>`
	background-color: #fff;
	flex: 70;
	position: relative;
	display: flex;
	flex-flow: column nowrap;
	position: relative;
	overflow: hidden;
	${({ twoFactorActive }) =>
		twoFactorActive &&
		`
		justify-content: center;
		padding-bottom: 100px;
	`}
`;

export const ClientFont = styled.p`
	margin: 0;
	font-weight: 600;
	font-size: 26px;
	line-height: 1.1;
	margin-left: 10px;
`;

export const ActionFont = styled.p`
	font-size: 38px;
	margin: 0;
	color: #808080;
	padding: 0 150px;
	margin-top: 50px;
	@media screen and (max-width: 1200px) {
		padding: 0 90px;
	}
	@media screen and (max-width: 550px) {
		padding: 0 50px;
	}
	@media screen and (max-height: 1000px) {
		font-size: 34px;
		margin-top: 20px;
	}
	@media screen and (max-height: 850px) {
		font-size: 32px;
		text-align: center;
	}
`;

export const ActionBottomFont = styled.p`
	padding: 0 150px;
	color: #808080;
	font-size: 29px;
	margin: 0;
	margin-bottom: 25px;
	@media screen and (max-width: 1200px) {
		padding: 0 90px;
	}
	@media screen and (max-width: 550px) {
		padding: 0 50px;
	}
	@media screen and (max-height: 1000px) {
		font-size: 24px;
	}
	@media screen and (max-height: 850px) {
		font-size: 22px;
		text-align: center;
	}
`;

export const LeftFoot = styled.div`
	width: 100%;
	height: 70px;
	position: absolute;
	bottom: 0;
	margin-left: -25px;
	display: flex;
	flex-flow: row nowrap;
	&::before {
		content: '';
		display: block;
		position: absolute;
		bottom: 70px;
		width: 100%;
		height: 30px;
		background: linear-gradient(0deg, #00000014, transparent);
		pointer-events: none;
	}
	p {
		margin: 0;
		line-height: 1.3;
	}
`;

export const FooterRight = styled.div`
	flex: 1;
	display: flex;
	flex-flow: column nowrap;
	justify-content: center;
	align-items: flex-end;
	padding-right: 40px;
	span {
		font-weight: 600;
	}
`;

export const PinContainer = styled.div`
	width: 300px;
	margin: 20px auto;
	margin-bottom: 40px;
	display: flex;

	/* Chrome, Safari, Edge, Opera */
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	input[type='number'] {
		-moz-appearance: textfield;
		appearance: textfield;
	}

	input {
		all: unset;
		background-color: #e8e8e8;
		flex: 1;
		width: unset;
		min-width: 0;
		height: 40px;
		margin: 0 7px;
		text-align: center;
		font-size: 18px;
		&:first-child {
			margin-left: 0;
		}
		&:last-child {
			margin-right: 0;
		}
	}
	@media screen and (max-width: 410px) {
		width: 270px;
	}
`;

export const ConfirmTopFont = styled.p`
	margin: 0;
	font-weight: 600;
	font-size: 20px;
	margin-top: 50px;
	text-align: center;
`;

export const ConfirmBottomFont = styled.p`
	text-align: center;
	margin: 0;
	margin-bottom: 10px;
	line-height: 1.3;
	margin-top: 8px;
`;

export const LogoImage = styled.img`
	width: 310px;
	margin: 50px auto;
	@media screen and (max-height: 1000px) {
		width: 270px;
		margin: 35px auto;
	}
	@media screen and (max-height: 850px) {
		width: 200px;
		margin: 0 auto;
	}
`;

export const FooterBottomFont = styled.p`
	text-align: center;
	font-size: 18px;
	color: #7d7d7d;
	span {
		color: #bc3547;
		font-weight: 600;
	}
	@media screen and (max-height: 850px) {
		font-size: 16px;
	}
`;

export const FooterContainer = styled.div`
	position: absolute;
	bottom: 10px;
	left: 50%;
	transform: translateX(-50%);
	width: 60%;
	@media screen and (max-width: 550px) {
		width: 85%;
		text-align: center;
	}
`;

export const FooterDivider = styled.div`
	width: 100%;
	margin: 30px 0;
	height: 2px;
	background-color: #e2e2e2;
`;

export const HelpFontContainer = styled.div`
	font-size: 18px;
	line-height: 0.6;
	margin-bottom: 80px;
	p:nth-child(1) {
		color: #a0a0a0;
	}
	p:nth-child(2) {
		color: #787878;
		font-weight: 600;
	}
	@media screen and (max-height: 1000px) {
		margin-bottom: 0;
	}
	@media screen and (max-height: 850px) {
		font-size: 16px;
	}
`;
